import React from "react";


export default function Contact() {
    return(
        <>
        <h1 id="center">Contact</h1>
        <div className="contact" id="contact">
            
             
                <div className="box">
                <i class="fa-brands fa-instagram"></i>
                <a href="https://www.instagram.com/developedbyjk/">Instagram</a>
                </div>
                
                <div className="box">
                <i class="fa-brands fa-github"></i>
                <a href="https://github.com/developedbyjk">Github</a>
                </div>
               
                <div className="box">
                <i class="fa-brands fa-linkedin"></i>
                <a href="https://www.linkedin.com/in/juned-khan-dev/">Linkedin</a>
                </div>
                <div className="box">
                <i class="fa-brands fa-x-twitter"></i>
                <a href="http://twitter.com/developedbyjk">Twitter</a>
                </div>

            </div>
            </>
    )
}